import clsx from 'clsx';
import { BarChart, CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts';

import { truncateText } from '@src/utils/commonUtils';

const BarGraph = ({
  data,
  children,
  wrapperClassName = '',
  width = 400,
  height = 350,
  barWidth = 70,
  margin = {
    top: 0,
    right: 0,
    left: 0,
    bottom: 30
  },
  axis = {
    x: { key: '', label: '' },
    y: { key: '', label: '', tickFormatter: value => `${value}%` }
  },
  tooltipProps = null
}) => {
  const handleScroll = e => {
    let wrapper = document.querySelector(
      `.bar-graph-wrapper .recharts-surface`
    );
    let graphWrapper = document.querySelector(
      `.bar-graph-wrapper .graph-wrapper`
    );

    const allAxis = document.querySelectorAll(
      `.bar-graph-wrapper .recharts-yAxis`
    );

    let xAxis = document.querySelector(`.bar-graph-wrapper .recharts-xAxis`);

    const xAxisHeight = xAxis.getBoundingClientRect().height;

    allAxis?.forEach(axis => {
      const orientation = axis
        .querySelector(`.bar-graph-wrapper .recharts-cartesian-axis-tick-line`)
        ?.getAttribute('orientation');

      const rect = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'rect'
      );
      const yAxisheight = axis.getBoundingClientRect().height;
      const yAxisWidth = axis.getBoundingClientRect().width;

      rect.setAttribute('x', '0');
      rect.setAttribute('y', '0');
      rect.setAttribute('width', yAxisWidth);
      rect.setAttribute('height', yAxisheight + xAxisHeight);
      rect.setAttribute('fill', 'var(--rs-color-background-base-primary)');
      rect.setAttribute('class', `y-axis-rect-${orientation}`);

      axis.insertBefore(rect, axis.firstChild);

      const position =
        orientation === 'left'
          ? e.target.scrollLeft
          : e.target.scrollLeft -
            wrapper?.clientWidth +
            graphWrapper?.clientWidth;

      axis.style = 'transform: translateX(' + position + 'px);';
    });
  };

  return (
    <div
      style={{
        maxWidth: width,
        overflow: 'auto',
        height: '100%'
      }}
    >
      <div
        className={clsx('bar-graph-wrapper', wrapperClassName)}
        onScroll={handleScroll}
      >
        <BarChart
          width={Math.max(width, data.length * barWidth)}
          height={height}
          data={data}
          margin={margin}
        >
          <XAxis
            dataKey={axis.x.key}
            fontSize={11}
            interval='preserveStartEnd'
            tickFormatter={value => truncateText(value)}
            label={{
              value: axis.x.label,
              style: { textAnchor: 'middle', fontSize: '11px' },
              angle: 0,
              position: 'insideBottom',
              offset: -10
            }}
          />

          <CartesianGrid
            strokeDasharray='3 3'
            stroke='var(--rs-color-foreground-base-secondary)'
            vertical={false}
            opacity={0.4}
          />
          <Tooltip
            {...(tooltipProps || {
              itemStyle: {
                color: 'var(--rs-color-foreground-base-primary)',
                fontSize: '11px'
              },
              labelStyle: {
                color: 'var(--rs-color-background-accent-emphasis-hover)',
                fontSize: '14px'
              },
              contentStyle: {
                backgroundColor: 'var(--rs-color-background-base-primary)',
                borderRadius: 'var(--rs-radius-2)',
                border: `1px solid var(--rs-color-border-base-secondary)`,
                padding: '8px',
                outline: 'none'
              }
            })}
          />
          {children}
          <YAxis
            dataKey={axis.y.key}
            type='number'
            tickFormatter={axis.y.tickFormatter}
            label={{
              value: axis.y.label,
              style: { textAnchor: 'middle', fontSize: '11px' },
              angle: -90,
              position: 'left',
              offset: -10
            }}
            fontSize={12}
          />
        </BarChart>
      </div>
    </div>
  );
};

export default BarGraph;
